<header class="topbar">
    <nav class="navbar top-navbar navbar-expand-md navbar-light" style="justify-content: center;align-items: center;">
        <div class="navbar-header">
            <a (click)="alertLogout();"><i class="fa-solid fa-sign-out"></i> Cerrar Sesión</a>
        </div>
    </nav>
</header>

<div class="card">
    <div class="card-body" style="margin-top: 70px !important;">
        <div class="container">
            <div class="row flexi">
                <h5 class="text-center" *ngIf="competitors.length > 0">
                    {{currentStation.name}} ({{currentStation.cre_id}})
                    <br>
                    <br>
                    Lista de competidores
                    <br>
                </h5>
            </div>

            <div class="row" style="margin-top: 20px;">
                <div class="table-overflow-container" #epltable>
                    <table *ngIf="competitors.length > 0" class="table table-hover htable btable no-margin no-padding">
                        <thead>
                            <tr>
                                <td *ngFor="let col of columns" [style.width]="col.width" [class]="col.styleClass"
                                    [attr.data-order]="col.order" [attr.data-name]="col.name">
                                    <span [class]="col.product">
                                        <strong>
                                            {{ col.label }}
                                        </strong>
                                    </span>
                                </td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr class="gp-station">
                                <td class="text-center">
                                    <label for="file">
                                        <i class="fa fa-camera"></i>
                                    </label>
                                    <input style="display: none;background: transparent;border: none;" id="file"
                                        type="file" accept="image/png, image/gif, image/jpeg" class="form-control"
                                        (change)="onFileChange($event, currentStation.name, currentStation.cre_id)">
                                </td>
                                <td>
                                    <p class="truncate" [title]="currentStation.name + ' - ' + currentStation.cre_id">
                                        {{currentStation.name}}<br>
                                        <span style="font-size:12px">{{currentStation.formatted_cre_id}}</span>
                                    </p>
                                </td>
                                <td class="text-center">- </td>
                                <td class="text-center">
                                    <img *ngIf="currentStation.brand?.includes('Pmx')"
                                        src="https://gaspre-app.s3.us-east-2.amazonaws.com/assets/images/Logo-Marcas/Pemex.png"
                                        width="40px" />
                                    <img *ngIf="!currentStation.brand?.includes('Pmx')"
                                        [ngClass]="{'size-18': currentStation.brand === 'Grupo Octano' , 'size-20': currentStation.brand === 'Power Gas' ||currentStation.brand === 'Chevron' || currentStation.brand === 'Ener' || currentStation.brand === 'Canelo', 'size-25': currentStation.brand === 'One' || currentStation.brand === 'Apex' || currentStation.brand === 'Wasconblue' || currentStation.brand === 'Grn' || currentStation.brand === 'Usfuel' || currentStation.brand === 'Ganagas' || currentStation.brand === 'Plusco' || currentStation.brand === 'Phillips 66' || currentStation.brand === '76' || currentStation.brand === 'Gulf' || currentStation.brand === 'BP' || currentStation.brand === 'Shell' || currentStation.brand === 'Repsol' || currentStation.brand === 'Oxxogas' || currentStation.brand === 'Carvel', 'size-30': currentStation.brand === 'San Javier', 'size-50': currentStation.brand === 'Fullgas', 'size-55': currentStation.brand === 'Total' || currentStation.brand === 'Gasbo', 'size-60': currentStation.brand === 'Arco' || currentStation.brand === 'Akron' || currentStation.brand === 'Smartgas' || currentStation.brand === 'Red Energy' || currentStation.brand === 'Redpetroil' || currentStation.brand === 'Servifacil' || currentStation.brand === 'Mi Gasolina' || currentStation.brand === 'Master Fuel' || currentStation.brand === 'Petroil'  || currentStation.brand === 'Indian', 'size-65': currentStation.brand === 'G500' || currentStation.brand === 'Redco' || currentStation.brand === 'Redgpa' || currentStation.brand === 'Black Gold' || currentStation.brand === 'Soriana' || currentStation.brand === 'Diesel Max' || currentStation.brand === 'Tesoro', 'size-70': currentStation.brand === 'Alcomex' || currentStation.brand === 'Goodprice' || currentStation.brand === 'Power Fuel' || currentStation.brand === 'Fullok' || currentStation.brand === 'Oktan' || currentStation.brand === 'Sin Marca' || currentStation.brand === 'Independiente', 'size-80': currentStation.brand === 'Gastol Fuel'}"
                                        src="https://gaspre-app.s3.us-east-2.amazonaws.com/assets/images/Logo-Marcas/{{currentStation.brand}}.png"
                                        alt="" width="40px" />
                                </td>
                            </tr>

                            <tr *ngFor="let cop of competitors;" [ngClass]="{'activate': cop.active}">
                                <td class="text-center">
                                    <label for="{{'file-' + cop.cre_id}}">
                                        <i class="fa fa-camera"></i>
                                    </label>
                                    <input style="display: none;background: transparent;border: none;"
                                        id="{{'file-' + cop.cre_id}}" type="file"
                                        accept="image/png, image/gif, image/jpeg" class="form-control"
                                        (change)="onFileChange($event, cop.name, cop.cre_id)">
                                </td>
                                <td>
                                    <div style="display: inline-block;width: 100%;vertical-align: middle;">
                                        <p class="truncate" [title]="cop.name + ' - ' + cop.cre_id">
                                            <i class="fa fa-camera-retro" style="cursor: pointer;font-size: 16px;"
                                                aria-hidden="true" data-toggle="modal" data-target="#modal-img"
                                                *ngIf="cop.uri_image_prices"
                                                (click)="setImg(cop.uri_image_prices, cop.name, cop.date_image_prices)"></i>
                                            {{cop.name}}
                                            <br> <span style="font-size:12px">{{cop.formatted_cre_id}}</span>
                                        </p>
                                    </div>
                                </td>

                                <td class="text-center">{{formatDistance(cop.distance)}}</td>
                                <td class="text-center">
                                    <img *ngIf="cop.brand?.includes('Pmx')"
                                        src="https://gaspre-app.s3.us-east-2.amazonaws.com/assets/images/Logo-Marcas/Pemex.png"
                                        width="40px" />
                                    <img *ngIf="!cop.brand?.includes('Pmx')"
                                        [ngClass]="{'size-18': cop.brand === 'Grupo Octano' , 'size-20': cop.brand === 'Power Gas' ||cop.brand === 'Chevron' || cop.brand === 'Ener' || cop.brand === 'Canelo', 'size-25': cop.brand === 'One' || cop.brand === 'Apex' || cop.brand === 'Esp' || cop.brand === 'Wasconblue' || cop.brand === 'Grn' || cop.brand === 'Usfuel' || cop.brand === 'Ganagas' || cop.brand === 'Plusco' || cop.brand === 'Phillips 66' || cop.brand === '76' || cop.brand === 'Gulf' || cop.brand === 'BP' || cop.brand === 'Shell' || cop.brand === 'Repsol' || cop.brand === 'Oxxogas' || cop.brand === 'Carvel', 'size-30': cop.brand === 'San Javier', 'size-50': cop.brand === 'Fullgas', 'size-55': cop.brand === 'Total' || cop.brand === 'Gasbo', 'size-60': cop.brand === 'Arco' || cop.brand === 'Akron' || cop.brand === 'Smartgas' || cop.brand === 'Red Energy' || cop.brand === 'Redpetroil' || cop.brand === 'Servifacil' || cop.brand === 'Mi Gasolina' || cop.brand === 'Master Fuel' || cop.brand === 'Petroil'  || cop.brand === 'Indian', 'size-65': cop.brand === 'G500' || cop.brand === 'Redco' || cop.brand === 'Redgpa' || cop.brand === 'Black Gold' || cop.brand === 'Soriana' || cop.brand === 'Diesel Max' || cop.brand === 'Tesoro', 'size-70':  cop.brand === 'Bristoil' || cop.brand === 'Alcomex' || cop.brand === 'Goodprice' || cop.brand === 'Power Fuel' || cop.brand === 'Fullok' || cop.brand === 'Oktan' || cop.brand === 'Sin Marca' || cop.brand === 'Independiente' , 'size-80': cop.brand === 'Gastol Fuel'}"
                                        src="https://gaspre-app.s3.us-east-2.amazonaws.com/assets/images/Logo-Marcas/{{cop.brand}}.png"
                                        alt="" width="40px" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <app-table-loader *ngIf="competitors.length === 0"></app-table-loader>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modal-img" tabindex="-1" role="dialog" aria-labelledby="viewImage" aria-hidden="true">
    <div class="modal-dialog medium-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" style="text-align: center;" id="viewImage">
                    {{imgNameSelected}}
                    <br>
                    Hora de la foto: {{imgDateSelected}} hrs.
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <img [src]="imgSelected" width="200px" height="300px">
            </div>
            <div class="footer-modal">
                <button type="button" class="add" data-dismiss="modal">Aceptar</button>
            </div>
        </div>
    </div>
</div>

<ng-template #photoModal let-modal class="modal-dialog modal-dialog-centered">
    <div class="modal-header">
        <h5 class="modal-title">
            <div class="header-c">
                ¿Enviar foto de: {{station}}?
            </div>
        </h5>
        <button type="button" class="close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding-top: 0;">
        <img [src]="imageSrc" style="width:100%;max-height: 70vh;">
    </div>
    <div class="footer-modal" style="padding-top: 0;">
        <button class="btn save" (click)="submit();">Enviar</button>
    </div>
</ng-template>